import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/cloud-support-and-maintenance-services/inner-banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner">Build Scalable Cloud Apps</h1> */}
              <h1 style={{ marginBottom: "10px" }}>
                Business-Grade Cloud Support and Maintenance Services
              </h1>
              <p>
                TekRevol helps its clients future-proof their digital
                transformation journey with cloud support and maintenance
                services. With our dedicated cloud maintenance professionals by
                your side, you can build and utilize secure cloud networks,
                capture better business value and achieve purpose and
                profitability – in the most efficient ways.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Manage my cloud setup!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
